import React, {useEffect, useRef, useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';
import AppConfirmDialog from '@crema/core/AppConfirmDialog';
import {Divider, Typography, styled} from '@mui/material';
import {CloseOutlined} from '@mui/icons-material';
import {ButtonContained} from 'shared/components/Button';
import DialogForm from './DialogForm';
import {useDispatch} from 'react-redux';
import {onGetTitleOptions} from 'redux/actions/admintools/Title';
import {
  onGetDetailAksiPerubahan,
  onPostAksiPerubahan,
  onPostJenisKategori,
  onUpdateAksiPerubahan,
} from 'redux/actions/AksiPerubahan';
import {useSelector} from 'react-redux';
import DialogAddKategori from './DialogAddKategori';
import {FETCH_ERROR, FETCH_SUCCESS} from 'shared/constants/ActionTypes';
import DialogAlert from './DialogAlert';

const ErrorText = styled('div')({
  color: '#800000',
  fontSize: '0.875rem',
  marginLeft: '7px',
  marginTop: '4px',
});

const DialogPerubahan = ({
  open = false,
  role = 'add',
  handleClose,
  detailData = null,
}) => {
  const [modalConf, setModalConf] = useState(false);
  const [formValue, setFormValue] = useState(null);
  const [dialogAlert, setDialogAlert] = useState(false);
  const [dialogAlertMessage, setDialogAlertMessage] = useState(false);

  const [uploadedFiles, setUploadedFiles] = useState(null);
  const {detail} = useSelector((state) => state.aksiPerubahan);
  const {error, message} = useSelector((state) => state.common);

  const dispatch = useDispatch();
  const childRef = useRef();

  useEffect(() => {
    if (detailData) dispatch(onGetDetailAksiPerubahan(detailData.id));
  }, [detailData]);

  useEffect(() => {
    if (childRef.current) childRef.current.resetForm();
    if(role === 'add') setUploadedFiles(null)
    
  }, [open]);

  useEffect(() => {
    console.log(error)

    if (error[0] === 'title already.' && open) {
      setDialogAlertMessage("Jenis Kategori sudah ada !")
      setDialogAlert(true);
    }
    if (error[0] === 'member already exist.' && open) {
      setDialogAlertMessage('Peserta sudah ada dalam Pelatihan !')
      setDialogAlert(true);
    }
    if (error[0] === 'peringkat already.' && open) {
      setDialogAlertMessage("Peringkat yang dipilih sudah digunakan oleh peserta lain!")
      setDialogAlert(true);
    }
    if (error[0] === 'anggota has limited.' && open) {
      setDialogAlertMessage("Jumlah Peserta Pelatihan Sudah Mencapai Batas!")
      setDialogAlert(true);
    }
  }, [error]);

  useEffect(() => {
    if (open) {
      if (childRef.current) childRef.current.resetForm();
      handleClose();
      setUploadedFiles(null)
    }
  }, [message]);

  useEffect(() => {
    if (detail && role !== 'add')
      setUploadedFiles({
        name: detail.file_name,
        type: 'pdf',
        size: 10000,
        file: '',
      });
  }, [detail]);

  const handleSubmitForm = () => {
    let val = childRef.current.returnForm();
    let formValues = JSON.parse(JSON.stringify(val.values));

    setFormValue(formValues);
    console.log(val);
    if (val.isValid && val.dirty && uploadedFiles && role !== 'add_category') setModalConf(true);
    if (val.isValid && val.dirty  && role === 'add_category') setModalConf(true);

  };

  const handleDialogLabel = (role) => {
    switch (role) {
      case 'add':
        return 'Tambah';
      case 'edit':
        return 'Ubah';
      case 'detail':
        return 'Detail';

      default:
        return '';
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        sx={{
          '& .MuiDialog-paper': {
            maxWidth: '800px !important',
            width: '750px',
            height: role === 'add_category' ? '350px' : '500px',
            borderRadius: '16px',
          },
        }}
      >
        <DialogTitle sx={{display: 'flex', justifyContent: 'space-between'}}>
          <Typography sx={{fontWeight: '600', fontSize: '18px'}}>
            {handleDialogLabel(role)}{' '}
            {role === 'add_category' ? 'JENIS KATEGORI' : 'AKSI PERUBAHAN'}
          </Typography>
          <CloseOutlined onClick={handleClose} />
        </DialogTitle>
        <Divider sx={{marginY: 2}} />
        {role !== 'add_category' ? (
          <DialogForm
            ref={childRef}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            detailData={detailData}
            role={role}
          />
        ) : (
          <DialogAddKategori
            ref={childRef}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            detailData={detailData}
            role={role}
          />
        )}

        
        <DialogContent
          sx={{
            '&::-webkit-scrollbar': {
              width: '0.5em',
            },
            '&::-webkit-scrollbar-track': {
              ' -webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.3)',
            },
            '&::-webkit-scrollbar-thumb': {
              background: 'darkgrey',
              outline: '1px solid slategrey',
            },
          }}
        ></DialogContent>
        <DialogActions>
          {role !== 'detail' ? (
            <Button
              variant='contained'
              onClick={handleClose}
              size='small'
              style={{
                width: '100px',
                backgroundColor: '#F5F5F5',
                color: '#9F9F9F',
              }}
            >
              BATAL
            </Button>
          ) : (
            ''
          )}
          {role !== 'detail' ? (
            <ButtonContained
              variant='contained'
              onClick={() => handleSubmitForm()}
            >
              SIMPAN
            </ButtonContained>
          ) : (
            ''
          )}
        </DialogActions>
      </Dialog>

      <AppConfirmDialog
        open={modalConf}
        onDeny={() => setModalConf(false)}
        onConfirm={() => {
          setModalConf(false);
          if (role === 'add') {
            dispatch(onPostAksiPerubahan(formValue, uploadedFiles.file));
          }
          if (role === 'edit') {
            dispatch(
              onUpdateAksiPerubahan(
                detailData.id,
                formValue,
                uploadedFiles.file,
              ),
            );

          }
          if (role === 'add_category') dispatch(onPostJenisKategori(formValue));

        }}
        title={
          `Apakah anda yakin akan ${
            role.includes('add') ? 'menyimpan' : 'mengubah'
          } ${role === 'add_category' ? 'JENIS KATEGORI' : 'AKSI PERUBAHAN'} ` +
          '?'
        }
        dialogTitle={`${role.includes('add') ? 'Tambah' : 'Ubah'} ${
          role === 'add_category' ? 'JENIS KATEGORI' : 'AKSI PERUBAHAN'
        }`}
      />
      <DialogAlert open={dialogAlert} message={dialogAlertMessage} onClose={() => setDialogAlert(false)} />
    </div>
  );
};

export default DialogPerubahan;

DialogPerubahan.propTypes = {
  open: PropTypes.bool,
  role: PropTypes.string,
  detailData: PropTypes.any,
  handleClose: PropTypes.func,
};
